var Timer = require('./../../countdowntimer/countdowntimer');
var VideoJs = require('video.js');
require('videojs-contrib-media-sources');
require('videojs-contrib-hls.js');

$(function () {
	try{
    //live drawing - header secondary row
    if (!$('#header-top-row-live-drawing-timer').length) return;
    let $topRowTimer = initializeHeaderTopRowLiveDrawingTimer();
    $topRowTimer.onExpire(handleHeaderTopRowLiveDrawingTimerExpireState);

    //live drawing - header top drawer
    if (!$('#header-top-drawer-live-draw-countdown-timer').length) return;
    let $topDrawerTimer = initializeHeaderTopDrawerLiveDrawingTimer();

    var player;

    //On livedrawing drawer open
    $('#navbar-collapse-livedrawing').on('shown.bs.collapse', function () {
        if (!$('#header-live-drawing-video-stream').length) return;

        player = handleHeaderTopDrawerLiveDrawingShownEvent(player);
    });

    //On livedrawing drawer collapse
    $('#navbar-collapse-livedrawing').on('hidden.bs.collapse', function () {
        handleHeaderTopDrawerLiveDrawingHiddenEvent(player);
    });
	}catch(err){console.log('live-drawing intialize: '+err.message);}
});

function handleHeaderTopRowLiveDrawingTimerExpireState() {
    let stuff = `<span>LIVE NOW</span>`;
    $('.navbar-collapse-toggle[data-target="#navbar-collapse-livedrawing"]').html(stuff);
}
try{
if(localStorage["refreshed"]=='true')
{}
else{
localStorage["refreshed"]=false;}}catch(e){
	console.log('Error in createlocalstorage:'+e);
	localStorage["refreshed"]=false;}
var pageReloadtime=$('#hdnPageReloadTime').val();
function initializeHeaderTopRowLiveDrawingTimer() {	
    let durationInSeconds = $('#header-live-drawing-timer-seconds-remaining').val();
	let printLogs=false;
    if (durationInSeconds) {      
		/*Adding timer changes*/
		var drawTime= new Date($('#header-live-drawing-date').val()).getTime();
		var currentTime=new Date().getTime();
		
		var duration =drawTime -currentTime;
        var hour = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var min = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
      //var sec = Math.floor(duration % 3600 % 60);
	  if(min>=0 && hour>=0 ){
		$('#header-top-row-live-drawing-timer').html((hour<10?"0"+hour:hour)+" Hr : "+(min<10?"0"+min:min)+ " Mins");
	  }
		let windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
        let mobile = windowWidth < 500;
        $('#navbar-collapse-livedrawing').removeAttr('style');
        if(mobile){ 
            $('header nav .nav-item').css({'padding':'0 7px'});            
            $('#header-top-row-live-drawing').css({'line-height':'14px'}); //'text-align':'center',                       
            $('#header-top-row-live-drawing-timer-container br').removeClass('hidden');
            $('#header-top-row-live-drawing-text,#header-top-row-live-drawing-timer').css({'font-size':'11px'});                 
        }
        else{  
            $('#header-top-row-live-drawing-timer-container br').addClass('hidden');                  
            $('header nav .nav-item,#header-top-row-live-drawing,#header-top-row-live-drawing-text,#header-top-row-live-drawing-timer').removeAttr('style');
        }        
        
	//console.log('hour: '+hour+' - ' +min+'localStorage["refreshed"]'+localStorage["refreshed"])
	    if(min==0 && hour==0 && localStorage["refreshed"]=='false')
		{
				if(printLogs){
					console.log('hour-mm: '+hour+' - ' +min+' localStorage["refreshed"]:'+localStorage["refreshed"]);
				}
				localStorage["refreshed"]=true;
				localStorage["enableLiveDraw"]=true;
			setTimeout(pageReload, pageReloadtime);
		}		
		else{localStorage["refreshed"]=false;}
        $('.navbar-collapse-toggle[data-target="#navbar-collapse-livedrawing"]').on('click', function (e) {
            //Prevent expanding live draw drawer until 5 minutes prior to live drawing
           	 try{
					if (localStorage["enableLiveDraw"]=='true') {
						if(printLogs){
							console.log('localStorage["enableLiveDraw"]='+localStorage["enableLiveDraw"]);
						}
					}
                    else if (min >5 || hour >0 ) {
                        e.preventDefault();
                        e.stopPropagation();
						if(printLogs){
						console.log('min: '+min+' is more');
						}
                    }else{localStorage["enableLiveDraw"]=true;
					//console.log('min: '+min+' no condition is satisfied');
					}
				}
				catch(err){
				    e.preventDefault();
                    e.stopPropagation();
					console.log('error there: '+err.message);
				}
        });
    }
}
 function pageReload() {
    localStorage["enableLiveDraw"]=false;
	location.reload(); 
}
setInterval(initializeHeaderTopRowLiveDrawingTimer, 15000);
function initializeHeaderTopDrawerLiveDrawingTimer() {
    let topdrawer_durationInSeconds = $('#header-top-drawer-live-draw-countdown-timer-seconds-remaining').val();
    if (topdrawer_durationInSeconds) {
        let $topdrawer_timer = new Timer("header-top-drawer-live-draw-countdown-timer", topdrawer_durationInSeconds);
        $topdrawer_timer.start();

        return $topdrawer_timer;
    }
}

function handleHeaderTopDrawerLiveDrawingShownEvent(player) {
    if (!player) {
        let newPlayer = VideoJs('#header-live-drawing-video-stream', {
            // autoplay: true,
            html5: {
                hlsjsConfig: {
                    debug: false
                }
            }
        });

        newPlayer.on('loadedmetadata', function () {
            newPlayer.play();
        });

        newPlayer.on('ended', function () {
            newPlayer.dispose();
        });

        return newPlayer;
    }

    return player;
}

function handleHeaderTopDrawerLiveDrawingHiddenEvent(player) {
    if (player) {
        player.pause();
    }
}


// WEBPACK FOOTER //
// ./shared/components/header2/live-drawing/live-drawing.js